import { fromJS } from 'immutable';

const initialState = fromJS({
  selectedSeasonName: '',
  seasonName: '',
  dateRanges: [],
  rateSets:[],
});

function addRatesWizard(state = initialState, { type, payload }) {
  switch (type) {
    case 'UPDATE_SEASON_IN_WIZARD_WITH_KEYPATH':
      return state.setIn(payload.keyPath, fromJS(payload.value));
    case 'ADD_DATE_RANGES_TO_SEASON':
      const dateRanges = payload.ranges.map(range => ({ seasonStartDate: range.from, seasonEndDate: range.to }));
      return state.set('dateRanges', fromJS(dateRanges));
    case 'ADD_RATE_SET_TO_SEASON':
      return state.update('rateSets', rateSets => rateSets.push(fromJS(payload)));
    case 'SAVING_SEASONRATES_TO_DB_STARTING':
      return state.set('saving', true);
    case 'SELECT_FROM_EXISTING_SEASON':
      return state.merge(fromJS(payload)).set('selectedSeasonName', payload.seasonName);
    case 'REMOVE_RATE_SET_FROM_SEASON_WHEN_GO_BACK':
      return state.set('rateSets', fromJS([]));
    case 'CLOSE_ADD_EDIT_CONTRACT_DIALOG':
    case 'PRODUCTS_SAVED_GO_TO_BILLING':
    case 'CONTRACT_PRODUCT_UPDATED':
      return initialState;
    default:
      return state;
  }
}

export default addRatesWizard;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/add-rates-wizard/add-rates-wizard-reducer.js